import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Modal } from "../../../../app/components";
import { makeStyles } from "@material-ui/styles";
import { CircularProgress } from "@material-ui/core";
import { useScheduleEvents } from "../../../../app/contexts/schedule.events.context";
import { NewScheduleForm } from "./new.schedule.events.form";
import PrimaryButton from "../../../../app/components/buttons/primary";
import OutlinedButton from "../../../../app/components/buttons/outlined";

const NewScheduleEventModal = (props) => {
  const classes = useStyles();
  const { scheduleOfEvents, saveLoading } = useScheduleEvents();
  const [formValid, setFormValid] = useState(false);
  const [SOEEventParameters, setSOEEventParameters] = useState({
    scheduleOfEventsName: "",
    scheduleOfEventsDescr: "",
    currency: "USD",
  });
  const [naToggles, setNaToggles] = useState({
    protocolVersion: false,
    protocolDate: false,
    currency: false,
  });
  const [errors, setErrors] = useState({
    scheduleOfEventsName: "",
    scheduleOfEventsDescr: "",
    visitIntervalType: "",
    visitWindowIntervalType: "",
    protocolVersion: "",
    protocolDate: "",
    currency: "", // Add currency to errors
  });

  useEffect(() => {
    const isValid =
      SOEEventParameters["scheduleOfEventsDescr"] &&
      SOEEventParameters["scheduleOfEventsName"] &&
      SOEEventParameters["visitIntervalType"] &&
      SOEEventParameters["visitWindowIntervalType"] &&
      (naToggles.protocolVersion || SOEEventParameters["protocolVersion"]) &&
      (naToggles.protocolDate || SOEEventParameters["protocolDate"]) &&
      !errors["scheduleOfEventsDescr"] &&
      !errors["scheduleOfEventsName"] &&
      !errors["visitIntervalType"] &&
      !errors["visitWindowIntervalType"] &&
      (!errors["protocolVersion"] || naToggles.protocolVersion) &&
      (!errors["protocolDate"] || naToggles.protocolDate);

    setFormValid(isValid);
  }, [SOEEventParameters, errors, naToggles]);

  const handleChange = (key, value) => {
    setSOEEventParameters({ ...SOEEventParameters, [key]: value });
    
    // Clear error by default
    let newError = "";
    
    // Check if empty
    if (!value && !naToggles[key]) {
      newError = "This field is required";
    }

    // Specific validations for scheduleOfEventsName
    if (key === "scheduleOfEventsName" && value) {
      if (!value.replace(/\s/g, "").length) {
        newError = "SOE name must contain at least 1 character";
      } else {
        // Check for duplicate names
        scheduleOfEvents.forEach((sp) => {
          if (
            sp?.scheduleOfEventsName.toLowerCase().trim() ===
            value.toLowerCase().trim()
          ) {
            newError = "Schedule of Events name must be unique";
          }
        });
      }
    }

    // Specific validation for scheduleOfEventsDescr
    if (key === "scheduleOfEventsDescr" && value) {
      if (!value.replace(/\s/g, "").length) {
        newError = "SOE description must contain at least 1 character";
      }
    }
    
    setErrors({ ...errors, [key]: newError });
  };

  const handleToggleChange = (field, isNA) => {
    setNaToggles((prev) => ({ ...prev, [field]: isNA }));
    if (isNA) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  return (
    <Modal
      size={700}
      {...props}
      aria-labelledby="New Schedule of Events"
      aria-describedby="Create a new schedule of events"
      title="New Schedule of Events"
    >
      <Container>
        <NewScheduleForm
          handleChange={handleChange}
          errors={errors}
          SOEEventParameters={SOEEventParameters}
          classes={classes}
          onToggleChange={handleToggleChange}
        />
        <ButtonContainer>
          <OutlinedButton onClick={props.onClose}>Cancel</OutlinedButton>
          <PrimaryButton
            disabled={saveLoading || !formValid}
            onClick={() => props.onContinue(SOEEventParameters)}
          >
            {saveLoading && (
              <CircularProgress
                style={{ color: "var(--White)" }}
                size="1em"
              />
            )}
            {!saveLoading && "Continue"}
          </PrimaryButton>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

export default NewScheduleEventModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
  padding: 1em;
  max-height: 75vh;
  overflow-y: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1em;
`;

const useStyles = makeStyles({
  asterisk: {
    color: "red",
  },
});